import PRODUCT_TYPES from '../definitions/ProductTypes';
import CardCalculationModalRewards from '../components/CardCalculationModalRewards';


/**
 * Choose the appropriate card calculation modal component based on the productType; undefined is allowed.
 * @param {string} productType - card’s product type
 * @returns {import('react').React.ReactElement|undefined} - the calculation modal component, or undefined
 */
function getExplanationModal(productType) {
    if (PRODUCT_TYPES_FOR_REWARDS_MODAL.includes(productType)) {
        return CardCalculationModalRewards;
    }

    return undefined;
}

const PRODUCT_TYPES_FOR_REWARDS_MODAL = [
    PRODUCT_TYPES.TRAVEL,
    PRODUCT_TYPES.CASH_BACK,
    PRODUCT_TYPES.ANY_REWARDS,
    PRODUCT_TYPES.STORE_CREDIT,
];


export default getExplanationModal;
